import { ListItemButton } from '@mui/material'
import { ReactNode } from 'react'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'

export type ListItemButtonWithNavigationProps = {
  path: string
  children: ReactNode
  dataTestId?: string
  onNavigate?: () => void
}

const ListItemButtonWithNavigation = ({
  path,
  children,
  dataTestId,
  onNavigate,
}: ListItemButtonWithNavigationProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = matchPath(
    {
      path,
      end: false,
    },
    location.pathname
  )

  return (
    <ListItemButton
      data-testid={dataTestId}
      href={path}
      onClick={(event) => {
        event.preventDefault()
        navigate(path)
        onNavigate?.()
      }}
      selected={!!isActive}
    >
      {children}
    </ListItemButton>
  )
}

export default ListItemButtonWithNavigation
